import * as React from 'react';
import styled from 'styled-components';
import { version } from './../config';
import { connect } from 'react-redux';

const StyledVersionSpan = styled.span`
  user-select: none;
  z-index: 1;
  text-decoration: none;
  color: #1f1f1f;
  letter-spacing: .5px;
  font-size: 0.8rem;
  margin-top: 7px;
`;

const VersionSpan = ({visible}) => {
    if(visible) {
        return (
            <StyledVersionSpan>
                {`v. ${version}`}
            </StyledVersionSpan> 
        );
    }
    return false;
}

const mapStateToProps = (state: State) => ({
    visible: state.domainProperties.get('versionVisible'),
});
export default connect(mapStateToProps, null)(VersionSpan);


// WEBPACK FOOTER //
// ./src/components/VersionSpan.jsx